import axios, { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';

import { ResponseList } from 'models/Response';
import { MenuMaster } from 'models/role';

export type UseMasterMenuProps = {
    enabled?: boolean;
    sid?: string;
    id?: string;
    menuName?: string;
};

export const useMasterMenu = (props?: UseMasterMenuProps) => {
    const { enabled, sid, id, menuName } = props || {};

    return useQuery({
        enabled,
        queryKey: ['master-menu', { sid, id, menuName }],
        queryFn: ({ signal }) => {
            const accessToken = localStorage.getItem('WF_APPLICATION');

            return axios.get<ResponseList<MenuMaster>>(
                '/v1/configuration/workflow/menu',
                {
                    signal,
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    },
                    params: {
                        sid,
                        id,
                        menu_name: menuName
                    }
                }
            );
        },
        select: (response: AxiosResponse<ResponseList<MenuMaster>>) =>
            response.data.result_list,
        retry: 1
    });
};
